import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type WhatsNewItemDataFragment = { __typename?: 'WhatsNewItem', availability?: string | null, date?: string | null, description?: string | null, id?: string | null, imageUrl?: string | null, link?: string | null, title?: string | null, type?: string | null };

export const WhatsNewItemData = /*#__PURE__*/ gql`
    fragment WhatsNewItemData on WhatsNewItem {
  availability
  date
  description
  id
  imageUrl
  link
  title
  type
}
    ` as unknown as DocumentNode<WhatsNewItemDataFragment, unknown>;

        

        
export const useWhatsNewItemDataFragment = (
  input: string | Omit<UseFragmentOptions<WhatsNewItemDataFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'WhatsNewItem' } };
    return input;
  })();

  return useFragment<WhatsNewItemDataFragment>({
    fragment: WhatsNewItemData,
    fragmentName: 'WhatsNewItemData',
    ...options,
  });
};
  
        